import { useStyles, Subheader, Grid } from '@archipro-design/aria';

import * as S from './Awards.style';
import type { AwardInfo } from '~/modules/professional/api/info-page-loader.server';
import { Link } from '@remix-run/react';
import { useIsDisabledInPreview } from '~/modules/root/hook/use-is-disabled-in-preview';

export const AwardRowFull: React.FC<AwardInfo> = ({
    AwardingInstitutionTitle,
    Title,
    YearAwarded,
    AwardedEntities,
}) => {
    const { css } = useStyles();
    const isInPreview = useIsDisabledInPreview('featured_tile_links');

    return (
        <Grid className={css(S.RowItem)}>
            <Subheader variant="01" className={css(S.RowDate)}>
                {YearAwarded}
            </Subheader>
            <Subheader variant="01" className={css(S.RowOrgName)}>
                {AwardingInstitutionTitle}
            </Subheader>
            <Subheader variant="01" className={css(S.RowAwardName)}>
                {Title}
            </Subheader>
            <Subheader variant="01" className={css(S.RowAwardEntity)}>
                {AwardedEntities.map((a, i) => (
                    <Link
                        className={css(S.DirectoryItemLink)}
                        key={i}
                        to={a.link}
                        target={isInPreview ? '_blank' : undefined}
                    >
                        <span className={css(S.UnderlinedLinkTitle)}>
                            {a.title || a.label}
                        </span>
                    </Link>
                ))}
            </Subheader>
        </Grid>
    );
};
